export default __webpack_public_path__ + "static/media/Limit Employee Access.6a6ec129.jpg";